import { getLang } from '../i18n/lang';

const TZ = 'Asia/Tashkent';

/**
 * Числа и даты форматируем по ru-RU в обоих языках: узбекская латиница
 * использует тот же порядок dd.MM.yyyy и пробел как разделитель разрядов,
 * а uz-UZ в Intl даёт непривычный формат. Локализуется только суффикс валюты.
 */
const CURRENCY_SUFFIX: Record<string, string> = { ru: 'сум', uz: 'soʻm' };

const moneyFmt = new Intl.NumberFormat('ru-RU', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const dateFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: TZ,
});

const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: TZ,
});

const numberFmt = new Intl.NumberFormat('ru-RU');

export function formatUzs(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined) return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(n)) return '—';
  return `${moneyFmt.format(n)} ${CURRENCY_SUFFIX[getLang()] ?? CURRENCY_SUFFIX.uz}`;
}

export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return numberFmt.format(n);
}

export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return dateFmt.format(date);
}

export function formatDateTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const date = typeof d === 'string' ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return '—';
  return dateTimeFmt.format(date);
}

/**
 * BCP-47 тег для `toLocaleDateString` там, где нужны названия месяцев и дней
 * недели (календарь публикаций). Узбекскую латиницу CLDR отдаёт по тегу 'uz'
 * («27-iyul», «Dush»).
 */
export function intlLocale(): string {
  return getLang() === 'uz' ? 'uz' : 'ru-RU';
}

export function maskCard(cardNumber: string | null | undefined): string {
  if (!cardNumber) return '—';
  const digits = cardNumber.replace(/\D/g, '');
  if (digits.length < 8) return cardNumber;
  return `${digits.slice(0, 4)} ${digits.slice(4, 8)} **** ${digits.slice(-4)}`;
}
